import { GET_TICKET_TYPE, SET_TICKET_TYPE } from "src/actions/types";
import { getCookieByName, setCookie } from "src/services/CookiesService";

const initialState = {
  ticketType: getCookieByName("ticketType"),
};
const filterReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case SET_TICKET_TYPE:
      setCookie(actions.payload.type);
      return {
        ...state,
        ...actions.payload,
      };
    case GET_TICKET_TYPE:
      return {
        ...state,
        type: state.ticketType,
      };
    default:
      return state;
  }
};

export default filterReducer;
